import Repository from "../Repository";

const resource = "/layouts";
export default {
    getAll(){
        return Repository.get(`${resource}`);
    },

    getOne(id) {
        return Repository.get(`${resource}/${id}`);
    },

    createLayout(json){
        return Repository.post(`${resource}`,json);
    },

    updateLayout(id, json) {
        return Repository.put(`${resource}/${id}`, json);
    },

    deleteLayout(id) {
        return Repository.delete(`${resource}/${id}`);
    }
}